import React from "react"
import PropTypes from "prop-types"
import exact from "prop-types-exact"
import { useTheme } from "@mui/material/styles"

import { Avatar } from "@mui/material"
import RoundedCard from "./RoundedCard"

// A small group of text with an icon used for listing features.

const IconTextBlock = ({ icon, head, text, link, linkText }) => {
  const theme = useTheme()

  return (
    <RoundedCard>
      {icon ? (
        <Avatar sx={{ bgcolor: theme.palette.accentThree.main }}>{icon}</Avatar>
      ) : null}
      <h3
        style={{
          color: theme.palette.primary.main,
          marginBottom: 5,
          marginTop: 12,
        }}
      >
        {head}
      </h3>
      <div>
        {text && <div>{text}</div>}
        {link && linkText && (
          <div>
            <a href={link}>{linkText}</a>
          </div>
        )}
      </div>
    </RoundedCard>
  )
}

IconTextBlock.propTypes = exact({
  icon: PropTypes.node,
  head: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  link: PropTypes.string,
  linkText: PropTypes.string,
})

IconTextBlock.defaultProps = {
  link: null,
  linkText: null,
  text: null,
  icon: null,
}

export default IconTextBlock
